var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 13H0.191406V4.82422H2.73438V13ZM1.47656 3.70312C1.07552 3.70312 0.729167 3.55729 0.4375 3.26562C0.145833 2.97396 0 2.6276 0 2.22656C0 1.82552 0.145833 1.47917 0.4375 1.1875C0.729167 0.895833 1.07552 0.75 1.47656 0.75C1.8776 0.75 2.22396 0.895833 2.51562 1.1875C2.80729 1.47917 2.95312 1.82552 2.95312 2.22656C2.95312 2.6276 2.80729 2.97396 2.51562 3.26562C2.22396 3.55729 1.8776 3.70312 1.47656 3.70312ZM12.25 13H9.70703V9.00781C9.70703 8.35156 9.65234 7.8776 9.54297 7.58594C9.34245 7.09375 8.95052 6.84766 8.36719 6.84766C7.78385 6.84766 7.3737 7.06641 7.13672 7.50391C6.95443 7.83203 6.86328 8.3151 6.86328 8.95312V13H4.34766V4.82422H6.78125V5.94531H6.80859C6.99089 5.58073 7.28255 5.27995 7.68359 5.04297C8.12109 4.7513 8.63151 4.60547 9.21484 4.60547C10.3997 4.60547 11.2292 4.97917 11.7031 5.72656C12.0677 6.32812 12.25 7.25781 12.25 8.51562V13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6a147e810d6103e5743c51dbed9dc5eb.svg";
export { ForwardRef as ReactComponent };